// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


require('./js/performance')

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import VueSocketio from 'vue-socket.io';
import socketio from 'socket.io-client'


//百度统计
import ba from 'vue-ba'
//引入mui库（微信手机端登录）
import mui from "./js/mui";
Vue.prototype.mui = mui

import isPlus from './js/isPlus'
Vue.prototype.isPlus = isPlus

//引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import apps from "./js/apps";
Vue.prototype.apps = apps

import utils from './dl.js'; // 引入刚才新建的js文件
Vue.prototype.$utils = utils

import ElementUI from 'element-ui' //element-ui的全部组件
import 'element-ui/lib/theme-chalk/index.css'//element-ui的css
Vue.use(ElementUI) //使用elementUI
Vue.config.productionTip = false

Vue.use(Element);
Vue.use(ba, '2089c3d13688755b6a83dfd0f5bc9a67');
Vue.use(ba, {
  siteId: '2089c3d13688755b6a83dfd0f5bc9a67'
});

//  Vue.use(VueSocketio,socketio('wss://monitor.desmix.com'));   //wss://monitor.desmix.com
// Vue.use(VueSocketio,socketio('ws://192.168.0.103:3000',
// {
//   transports: ['websocket']
// }));   //wss://monitor.desmix.com
Vue.use(new VueSocketio({
  debug: false,
  connection: socketio(process.env.baseWS, {
    transports: ['websocket']
  }),
  //connection: socketio('ws://localhost:3000', {transports: ['websocket']}),
  //connection: socketio('wss://monitor.desmix.com', {transports: ['websocket']}),
  vuex: {
    store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_'
  }
}))
//跳转后页面回到顶部
router.afterEach((to, from, next) => {

  window, scrollTo(0, 0)

})
/* eslint-disable no-new */

new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js